export default __webpack_public_path__ + "static/media/index-pop-close.989f8601.svg";